import React from "react";
import { Play } from "lucide-react";

interface MentorVideoSectionProps {
  videoUrl: string | null;
}

// Função para extrair o ID do vídeo do YouTube de diferentes formatos de URL
const getYouTubeVideoId = (url: string): string | null => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/v\/([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

export const MentorVideoSection: React.FC<MentorVideoSectionProps> = ({ videoUrl }) => {
  if (!videoUrl || videoUrl.trim() === "") {
    return null;
  }

  const videoId = getYouTubeVideoId(videoUrl);
  
  if (!videoId) {
    console.warn("URL de vídeo inválida:", videoUrl);
    return null;
  }

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  return (
    <div className="mt-6">
      <div className="bg-[#131922] border border-[#222A35] rounded-lg overflow-hidden">
        <div className="relative aspect-video bg-black">
          <iframe
            src={embedUrl}
            title="Vídeo do Mentor"
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}; 